module.exports = __webpack_public_path__ + "static/img/015.e87778e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/015.png
// module id = Ddl0
// module chunks = 1